<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>任务详情&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>

    <div class="rwbt">
      <div class="bwbt_1">
          {{rwinfo.title}}
      </div>
      <div class="uinfo">
      	<div class="uinfo_1">
      	<ul class="list-group">
      	 <li class="list-group-item  userliebiao" style="border-top:solid 1px #E5EAEC !important ;">
      	 	<div class=" col-sm-3 col-3 col-md-3" >
      			开始时间
      		</div>
      		<div class=" col-sm-9 col-9 col-md-9 right_sj" >
      			 {{rwinfo.start_time}}
      		</div>
      	 </li>
      	<li class="list-group-item  userliebiao">
      		<div class=" col-sm-3 col-3 col-md-3" >
      			结束时间
      		</div>
      		<div class=" col-sm-9 col-9 col-md-9 right_sj" >
             {{rwinfo.end_time}}
          </div>
      	</li>

      	<li class="list-group-item  userliebiao" style="border-bottom: none !important;">
      		<div class=" col-sm-3 col-3 col-md-3" >
      			任务状态
      		</div>
      		<div class=" col-sm-9 col-9 col-md-9 jxz right_sj"  v-if="rwinfo.sts == '进行中'">
               {{rwinfo.sts}}
      		</div>
          <div class=" col-sm-9 col-9 col-md-9 jiahong right_sj"  v-else>
               {{rwinfo.sts}}
          </div>
      	</li>



      	</ul>
      	</div>
      </div>


    </div>

  <div class="rwbt rwbtaaa">
    <div class="bwbt_11">
        量表列表
    </div>
    <div class="lblb_list">
        <div class="lblb col-sm-6 col-6 col-md-6  " v-for="item in listdata" >
            <div class="lblb_1"  @click="handleClick(item)" v-if="item.evaluationStatus == 0">
                <div class="ztxs">
                    未测
                </div>

                <div class="zwf"></div>
                <div class="ztxs_bt">{{item.gaugeName}}</div>
                <div class="ckxq"> 查看详情</div>
            </div>

            <div v-else>

              <div v-if="item.answerType == 0" class="lblb_1"  @click="tz('/user/wdcpdetail/'+item.id+'/'+taskId+'/'+item.gaugeName)" >

                  <div class="ztxs yice">
                     已测
                  </div>
                  <div class="zwf"></div>
                  <div class="ztxs_bt">{{item.gaugeName}}</div>
                  <div class="ckxq"> 查看详情</div>
              </div>
                <div v-else-if="item.answerType == 1" class="lblb_1"  @click="tz('/user/wdcpdetail1/'+item.id+'/'+taskId+'/'+item.gaugeName)" >

                    <div class="ztxs yice">
                       已测
                    </div>
                    <div class="zwf"></div>
                    <div class="ztxs_bt">{{item.gaugeName}}</div>
                    <div class="ckxq"> 查看详情</div>
                </div>
                <div v-else-if="item.answerType == 2" class="lblb_1"  @click="tz('/user/wdcpdetail2/'+item.id+'/'+taskId+'/'+item.gaugeName)" >

                    <div class="ztxs yice">
                       已测
                    </div>
                    <div class="zwf"></div>
                    <div class="ztxs_bt">{{item.gaugeName}}</div>
                    <div class="ckxq"> 查看详情</div>
                </div>
            </div>

        </div>

    </div>


  </div>


    <div class="bkx">

    </div>

		<div class="footer ">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/cprw')">
				<div class="dibumenu">
          	<!-- <img src="../../static/wd.png" > -->
             <img src="../../assets/img/cp_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/index')">
				<div class="dibumenu">
					 <img src="../../assets/img/wd.png" >
				</div>
				<div class="xmtitle ">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {getrwdetail } from '../../api/baseset'
  export default {
      data() {
        return {
          taskId:'',
          listdata:[],
          rwinfo:{
            title:'',
            start_time:'',
            end_time:'',
            sts:'',
             isShow:false
          }
        }
      },
      mounted() {

          if(localStorage.getItem('rw_data')){
              const data = JSON.parse(localStorage.getItem('rw_data'))

              this.rwinfo.title = data.title;
              this.rwinfo.start_time = data.start_time;
              this.rwinfo.end_time = data.end_time;
              this.rwinfo.sts = data.rwzt;
          }
          this.taskId = this.$route.params.id;


         this.getdata(this.taskId);
     // this.getsjtjs();
      },

      onShow: function() {

             this.taskId = this.$route.params.id;
              this.rwinfo.title = this.$route.params.title;
              this.rwinfo.start_time = this.$route.params.starttime;
              this.rwinfo.end_time = this.$route.params.endtime;
              this.rwinfo.sts = this.$route.params.sts;

             this.getdata(this.taskId);
        },
         onLoad: function() {
            // 页面创建时执行

          },

      methods: {

        getdata(id){
        //evaluationStatus  大于0 已测 0 未测
          this.loading = true
          let parm = {taskId:id}
            getrwdetail(parm)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {
                // console.log(res.data)
                 this.listdata = res.data;

               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },


        tz(url){

          this.$router.push(url);
        },
        fh(){
         window.history.go(-1);
        },
        handleClick(row){
            localStorage.setItem('profileData', JSON.stringify({
              title: row.gaugeName,
              explain:row.gaugeExplain,
              rwid:this.taskId,
              lbid:row.id,
              answerType:row.answerType
             // kszt:row.
            /* 其他数据 */
            }))
             let url;

            if(row.answerType =='1'){
               url = "/user/cpjsa/"+row.id
            }else if(row.answerType =='2'){
               url = "/user/cpjsa1/"+row.id
            }else{
              url = "/user/cpjs/"+row.id

            }

          //  this.$emit('event-name', '传递的值');
           this.$router.push(url);
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}

  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px;

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 14px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}


    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }


    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;
    	padding-left: 2% !important;
    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	margin: 0 auto;
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 10px;
    }
    .uinfo{
    	width: 100%;
    	height: auto;
    	/* padding-top: 5px;
    	padding-bottom: 5px; */
    	background-color: white;
      font-size: 14px;
    }
    .uinfo_1{
    	width: 88%;
    	height: auto;
    	margin: 0 auto;
    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 2.5rem;
    	line-height:2.5rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;

    	background-color: white;
    }

    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
    .rwbt{
      width: 100%;
      height: auto;

      background-color: white;
      margin-top: 15px;
       box-shadow: 2px 2px 2px 2px #ccc,-2px -2px 2px 2px #ccc;
    }
    .rwbtaaa{
       box-shadow: 0 0 0 0 ;
    }
    .bwbt_1{
      width: 92%;
      height: 3rem;
      margin: 0 auto;
      line-height: 3rem;
      /* border: solid 1px #ccc; */
     /* padding-top: -10px; */
      font-size:14px;
      color: black;
      font-weight: bold;

    }
    .bwbt_1::before {
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #00DDA3;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .bwbt_11{
        width: 92%;
        height: 3rem;
        margin: 0 auto;
        line-height: 3rem;

        font-size:14px;
        color: black;
        font-weight: bold;

      }
      .bwbt_11::before{
        content: "   ";
        display:inline-block;
        position: relative;
        width: 5px;
          /* background-color: red; */
        border-left:solid 5px #FF6712;
        height: 25px;
        padding-left: 7px;
        top:5px;
      }
      .right_sj{
        text-align: right;
      }
      .jxz{
        color: #00DDA3;
        font-weight: bold;
      }
      .lblb{
        height: 120px;

        /* border-right:solid 1px red; */
      }
      .lblb_list{
        width: 96%;
        margin: 0 auto;
        height: auto;
        padding-top:5px;
        padding-bottom: 5px;
        /* border: solid 1px green; */
        display: flex;
        flex-wrap: wrap;
      }
      .lblb_1{
        width:94%;
        height: 100px;
        border-radius: 5px 5px 5px 5px;
        box-shadow: 1px 1px 2px 2px #ccc,-1px -1px 2px 2px #ccc;
        margin-left: 4%;
        /* border: solid 1px red; */
      }
      .ztxs{
            color: white;
            width: 50px;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            text-align: center;
            background-color: #00DDA3;
            position: relative;
            top: 0;
            left: 0;
            float: right;
      }
      .ztxs::before{
          content: "";
            width: 0;
            height: 0;
            border-color: transparent #00DDA3;
            border-width: 0 0 6px 30px;
            border-style: solid;
            position: absolute;
            top: 20px;
            left: 0;
      }
      .ztxs::after{
        content: "";
            width: 0;
            height: 0;
            border-color: #00DDA3 transparent;
            border-width: 8px 0 0 30px;
            border-style: solid;
            position: absolute;
            top: 20px;
            left: 20px;
      }

     .yice{
           color: white;
           width: 50px;
           height: 20px;
           line-height: 20px;
           font-size: 14px;
           text-align: center;
           background-color: #FF6712;
           position: relative;
           top: 0;
           left: 0;
           float: right;
     }
     .yice::before{
         content: "";
           width: 0;
           height: 0;
           border-color: transparent #FF6712;
           border-width: 0 0 6px 30px;
           border-style: solid;
           position: absolute;
           top: 20px;
           left: 0;
     }
     .yice::after{
       content: "";
           width: 0;
           height: 0;
           border-color: #FF6712 transparent;
           border-width: 8px 0 0 30px;
           border-style: solid;
           position: absolute;
           top: 20px;
           left: 20px;
     }
     .ztxs_bt{
       width: 96%;
       font-size: 14px;
       /* padding-top: 35px; */
       /* border: solid 1px red; */
       margin: 0 auto;
       color: #666666;
       height: 50px;
       line-height: 45px;
       white-space: nowrap;
      /* border: solid 1px red; */
        overflow: hidden;
         text-overflow: ellipsis;
         text-align: center;
     }
     .ckxq{
       width: 100%;
       height: 20px;
       background-color: #00DDA3;
       color: white;
       text-align: center;
       font-size: 14px;
       line-height: 20px;
       border-radius: 0 0 5px 5px;
     }
     .zwf{
       width: 100%;
       height: 30px;
       /* border: solid 1px green; */
     }
</style>



// WEBPACK FOOTER //
// src/views/user/rwxq.vue